export const FETCH_API_KEYS = 'FETCH_API_KEYS';
export const DELETE_API_KEY = 'DELETE_API_KEY';
export const CREATE_API_KEY = 'CREATE_API_KEY';
export const SET_API_KEYS = 'SET_API_KEYS';